export const positions = [
  "Gk",
  "Lb",
  "Lcb",
  "Ccb",
  "Rcb",
  "Rb",
  "Cdm",
  "Lcm",
  "Rcm",
  "Lm",
  "Rm",
  "Ls",
  "Rs",
  "Cam",
  "Lf",
  "Rf",
  "St",
  "Lw",
  "Rw",
  "Ldm",
  "Rdm",
  "Cm",
  "Cf",
  "Lam",
  "Ram",
];
